const PictViewClass = require('pict-view');

class LIMSDocumentRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.DocumentDetails = {};
		this.ActiveDocumentLogs = [];
		this.LIMSDocumentRecordBackTo = null;
		this.manifest = require('./defaultDocumentEditManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.DocumentDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Edit');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Document', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-DocumentEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-DocumentEdit'].options.DefaultDestinationAddress = '#LIMSDocumentRecordEdit-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-DocumentEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-DocumentEdit'].rebuildCustomTemplate();
				this.log.info('Document Details view rendered with Active Record', this.AppData.DocumentDetails);

				// get the IDDocument from the router parameters
				const tmpGUIDDocument = this.pict.providers.LIMSRouter.currentView.split('/')[1];
				if (tmpGUIDDocument)
				{
					this.log.info('Document Details view opened with GUIDDocument', tmpGUIDDocument);
					// get the Document record by ID
					const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByGUID(tmpGUIDDocument);
					if (tmpRecord)
					{
						this.AppData.DocumentDetails = tmpRecord;
						this.log.info('Document Details view opened with Document record', this.AppData.DocumentDetails);
					}
					else
					{
						this.log.error('Document record not found for ID', tmpGUIDDocument);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Document Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {object} pDocumentRecord - The Document record to view
	 * @param {string} pOpenTab - The tab to open when the Document detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showDocumentDetailView(pIDDocument, pDocumentRecord, pOpenTab = 'Details')
	{
		// if a Document record is passed in, use it, otherwise get the Document record by ID
		if (pDocumentRecord)
		{
			this.AppData.DocumentDetails = Array.isArray(pDocumentRecord) ? pDocumentRecord[0] : pDocumentRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByID(pIDDocument);
			this.AppData.DocumentDetails = tmpRecord;
		}
		// render the Document detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Document Details View Rendered with Active Record', this.AppData.DocumentDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-DocumentEdit'].render();
		this.pict.views['PictSectionForm-DocumentEdit'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async saveDocumentChanges()
	{
		this.log.info('Saving Document changes');
		const tmpDocument = this.AppData.DocumentDetails;
		// Remove field we shouldn't save.
		const removedFields = [ 'CreateDate', 'UpdateDate', 'DeleteDate', 'CreatingIDUser', 'DeletingIDUser', 'Deleted', 'UpdatingIDUser', 'ParentDocument' ];
		for (const r of removedFields)
		{
			delete tmpDocument[r];
		}
		if (tmpDocument.DocumentDate?.length && !tmpDocument.DocumentDate.includes('T'))
		{
			tmpDocument.DocumentDate = this.fable.Dates.dayJS(tmpDocument.DocumentDate + this.pict.providers.DocumentProvider.getDocumentDateCurrentTime()).toISOString();
		}
		// save the Document
		const tmpResult = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.updateEntity('Document', tmpDocument, (pError, pResult) =>
			{
				if (pError)
				{
					reject(pError);
				}
				resolve(pResult);
			});
		});
		if (tmpResult)
		{
			this.log.info('Document changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Document changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Document changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Document changes', type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('No active Document to view');
			return;
		}
		this.log.info('Going to Read Document view for Document GUID:', this.AppData.DocumentDetails.GUIDDocument);
		this.pict.providers.LIMSRouter.router.navigate(`/Document/${ this.AppData.DocumentDetails.GUIDDocument }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Document form submitted');

		this.saveDocumentChanges();
	}
}

module.exports = LIMSDocumentRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSDocumentRecordEdit',
	DefaultRenderable: 'LIMSDocumentRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSDocumentRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-document-id="{~D:Record.IDDocument~}" onsubmit="_Pict.views.LIMSDocumentRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSDocumentRecordEdit-DocumentHeader:AppData.DocumentDetails~}
				<!-- Document Panel Tabs -->
				{~T:LIMSDocumentRecordEdit-Panel-Tabs:AppData.DocumentDetails~}
				<!-- LIMSDocumentRecord Content > Tab Details View -->
				<div id="LIMSDocumentRecordEditPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSDocumentRecordEdit-Details-Container">{~T:LIMSDocumentRecordEdit-Tab-Details:AppData.DocumentDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">	
				<ul>				
					<li class="is-active">
						<a id="LIMSDocumentRecordEditPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSDocumentRecordEdit.toggleTabContent(event, 'LIMSDocumentRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSDocumentRecordViewPanel-Print-Tab" onclick="_Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DocumentHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">
						{~TIfAbs:LIMSDocumentRecordEdit-DatumValue-Name:Record:Record.Name^>^0~}
						{~TIfAbs:LIMSDocumentRecordEdit-DatumValue-Name-Empty:Record:Record.Name^<=^0~}
					</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-file fa-sm"></i>
						</span>
						<span class="icon-text">Type: {~DocumentTypeName:Record.DocumentType~}</span>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSDocumentRecordEdit-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSDocumentRecordEdit-Tab-Details-Buttons-Edit:AppData.DocumentDetails~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSDocumentRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSDocumentRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSDocumentRecordEditPanel-Logs-Add-Button" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Document #{~D:Record.IDDocument~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSDocumentRecordEdit-DatumValue-ParentDocument',
			Template: /*html*/`{~D:Record.ParentDocument.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSDocumentRecordEdit',
			TemplateHash: 'LIMSDocumentRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
